import packages from '../../js/package';
// import original from '../../js/original';
import '../css/style.scss';

// npmでインストールしたパッケージの読み込み
packages();

// オリジナルパーツ読み込み
// original();


// 新規のコードはこのカッコの中に記載してください。

window.onload = function(){
    jQuery(function(jQuery) {

        // PC/SP振り分け（必要なときに使ってください。）
        var windowWidth = jQuery(window).width();
        var windowSm = 768;
        if (windowWidth <= windowSm) {
            //横幅768px以下のとき（つまりスマホ時）に行う処理を書く

        
        } else {
            //横幅840px超のとき（タブレット、PC）に行う処理を書く
        }
        
        // ハンバーガーメニュー
        jQuery('.navToggle').click(function() {
            jQuery(this).toggleClass('active');

            if (jQuery(this).hasClass('active')) {
                jQuery('#gnav').addClass('active');
                jQuery('body').addClass('active');
            } else {
                jQuery('#gnav').removeClass('active');
                jQuery('body').removeClass('active');
            }
        });
            // メニュー外をタップした時：SP用
            jQuery(document).on('touchstart',function(e) {
                        if(!jQuery(e.target).closest('#nav').length) {
                            // ターゲット要素の外側をタップした時の操作
                            jQuery('.navToggle').removeClass('active');
                            jQuery('#gnav').removeClass('active');
                            jQuery('body').removeClass('active');

                        } else {
                            // ターゲット要素をタップした時の操作（今回は不要）
                    }
            });
            // メニュー外をクリックした時：PC用
            jQuery(document).on('click',function(e) {
                        if(!jQuery(e.target).closest('#nav').length) {
                            // ターゲット要素の外側をクリックした時の操作
                            jQuery('.navToggle').removeClass('active');
                            jQuery('#gnav').removeClass('active');
                            jQuery('body').removeClass('active');

                        } else {
                            // ターゲット要素をクリックした時の操作（今回は不要）
                    }
            });

            // メニューをクリックした時：SP用
            jQuery('.dl-menu li a').on('click',function() {
                jQuery('.navToggle').removeClass('active');
                jQuery('body').removeClass('active');
                jQuery('#gnav').removeClass('active');
            });

        // ページトップへのボタン（スクロール＆出現タイミング）
        var topBtn = jQuery('#page-top');
        topBtn.hide();
        //スクロールが100に達したらボタン表示
        jQuery(window).scroll(function () {
            if (jQuery(this).scrollTop() > 100) {
                topBtn.fadeIn();
            } else {
                topBtn.fadeOut();
            }
        });
        //スクロールしてトップ
        topBtn.click(function () {
            jQuery('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        });

        //ページ内スムーススクロール
        jQuery('a[href^="__dummy__"]').click(function() {
            var speed = 400;
            var href= jQuery(this).attr("href");
            var target = jQuery(href == "__dummy__" || href == "" ? 'html' : href);
            var position = target.offset().top;
            jQuery('body,html').animate({scrollTop:position}, speed, 'swing');
            return false;
        });

        // スクロールイベント：ヘッダー
        const header = jQuery('.main-header');
        jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() >= 200) {
            header.addClass('fixed-header');
        } else {
            header.removeClass('fixed-header');
        }
        });

        // MV（スライダー）
        jQuery('.mv-slide-container').slick({
            infinite: true,
            speed: 1200,
            slidesToShow: 1,
            arrows: true,
            fade: true,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true,
            // asNavFor: ".mv-local-nav",
      
            responsive: [
                {
                  breakpoint: 480,
                  settings: {
                  slidesToShow: 1,
                  },
                },
              ],
        });

        // 高さを揃える
        jQuery('.index-container .index-item h3').matchHeight();
        jQuery('.index-container .index-item p').matchHeight();
        jQuery('.services-sub-menu .category-item .menu li:nth-of-type(1) a').matchHeight();
        jQuery('.services-sub-menu .category-item .menu li:nth-of-type(2) a').matchHeight();
        // jQuery('.blog-index .blog-item .text-container a .text-box h3').matchHeight();
        jQuery('.blog-index .blog-item .text-container a').matchHeight({byRow: false});
        jQuery('.blog .blog-index .blog-item .text-container a').matchHeight();

        // 文字数カット
        // var count = 50;
        // jQuery('.recruit .blog-index .blog-item .text-container .text-box p').each(function() {
        //   var thisText = jQuery(this).text();
        //    var textLength = thisText.length;
        //     if (textLength > count) {
        //        var showText = thisText.substring(0, count);
        //        var insertText = showText += '…';
        //        jQuery(this).html(insertText);
        //    };
        // });

        // スクロールして表示領域に入ったらclass付与
        jQuery(".js-fadeUp").on("inview", function () {
            jQuery(this).addClass("is-inview");
        });
        jQuery(".js-fadeTopTitle01").on("inview", function () {
            jQuery(this).addClass("is-inview");
        });
        jQuery(".js-fadeTopTitle01-1").on("inview", function () {
            jQuery(this).addClass("is-inview");
        });
        jQuery(".js-fadeTopTitle01-2").on("inview", function () {
            jQuery(this).addClass("is-inview");
        });
        jQuery(".js-fadeTopTitle01-3").on("inview", function () {
            jQuery(this).addClass("is-inview");
        });
        jQuery(".js-fadeTopTitle02").on("inview", function () {
            jQuery(this).addClass("is-inview");
        });

        jQuery(window).on('scroll', function() {
            jQuery('.js-fadeLeft').each(function() {
            
             var elemPosition = jQuery(this).offset().top,
                 windowHeight = jQuery(window).height(),
                 scroll = jQuery(window).scrollTop();
            
             if (scroll > elemPosition - windowHeight) {
                 jQuery(this).addClass('is-inview');
             }
          });
        });

        jQuery(window).on('scroll', function() {
            jQuery('.js-fadeRight').each(function() {
            
             var elemPosition = jQuery(this).offset().top,
                 windowHeight = jQuery(window).height(),
                 scroll = jQuery(window).scrollTop();
            
             if (scroll > elemPosition - windowHeight) {
                 jQuery(this).addClass('is-inview');
             }
          });
        });

        // スクロールヒント
        new ScrollHint('.scroll-table');

        // 個人情報の取り扱いについて内容を確認し、同意します。（チェックなしだと送信できない仕様）
        jQuery("#confirm").prop("disabled", true);
        jQuery("#information-confirmation").click(function(){
          if (jQuery(this).prop("checked") == false) {
            jQuery("#confirm").prop("disabled", true);
          } else {
            jQuery("#confirm").prop("disabled", false);
          }
        });

        // 年別やカテゴリーのCurrent設定
        let currentUrl = window.location.href;
        jQuery('.sub-list li a').each(function () {
            let linkUrl = jQuery(this).attr('href');
            if (currentUrl === linkUrl) {
                jQuery(this).addClass('current');
            }
        });

    });

    // ローディング（初回のみ発火タイプ）
    const webStorage = function () {
        if (sessionStorage.getItem('visit')) {
        /*
          2回目以降アクセス時の処理
        */
          jQuery(".loader-bg").addClass('loaded'); // .loadedを付与して非表示にする
          jQuery("body").css('display','block'); // 

        } else {
        /*
          初回アクセス時の処理
        */
          sessionStorage.setItem('visit', 'true'); 
          
            //読み込みが完了したら実行する
            jQuery(".loader-bg").removeClass('loaded'); // .loadedを外して表示させる（デフォルトでは付与状態）
            jQuery("body").css('display','block'); // 
            jQuery(window).on('load',function(){
                //ローディングアニメーションをフェードアウト
                jQuery('.loader').delay(600).fadeOut(600);
                //背景色をフェードアウト
                jQuery('.loader-bg').delay(900).fadeOut(800);
            });

            //ページの読み込みが完了してなくても5秒後にアニメーションを非表示にする
            setTimeout(function(){
                jQuery('.loader-bg').fadeOut(600);
            },5000);

        }
      }
      webStorage();
};